import { createContext, useContext, useState } from "react";

const WorkspaceContext = createContext(null);

export function WorkspaceProvider({ children }) {
  const [workspaceListing, setWorkspaceListing] = useState(null);
  const [workspaceHasChanges, setWorkspaceHasChanges] = useState(false);

  // clear changes flag whenever listing is cleared
  const clearWorkspace = () => {
    setWorkspaceListing(null);
    setWorkspaceHasChanges(false);
  };

  return (
    <WorkspaceContext.Provider value={{
      workspaceListing,
      setWorkspaceListing,
      workspaceHasChanges,
      setWorkspaceHasChanges,
      clearWorkspace,
    }}>
      {children}
    </WorkspaceContext.Provider>
  );
}

export function useWorkspace() {
  return useContext(WorkspaceContext);
}
